"use client"

import React from "react"
import ReactDOM from "react-dom"
import ReactPlayer from "react-player"

import XOut from "../../../public/icons/x-out.svg"

interface VideoPlayerProps {
  youtubeVideoId: string
  title: string | undefined
  playing?: boolean
  className?: string
}

// Video player component
export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  youtubeVideoId,
  playing,
  title,
  ...props
}) => (
  <ReactPlayer
    url={youtubeVideoId}
    playing={playing}
    controls
    width="100%"
    height="100%"
    className="rounded-lg react-player"
    title={title}
    {...props}
  />
)

interface VideoModalProps {
  youtubeVideoId: string
  toggle: any
  isShowing: boolean
  title: string | undefined
}

const VideoPlayerModal: React.FC<VideoModalProps> = ({
  youtubeVideoId,
  toggle,
  isShowing,
  title,
  ...props
}) =>
  isShowing &&
  ReactDOM.createPortal(
    <div
      role="button"
      tabIndex={0} // Makes the div focusable
      onClick={toggle}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          toggle()
        }
      }}
      className="modal flex justify-center items-center fixed inset-0 bg-black bg-opacity-75 z-50"
    >
      <button
        type="submit"
        aria-label="close-video"
        onClick={toggle}
        className="absolute top-8 right-8 p-4 z-10"
      >
        <XOut className="h-6 w-6 text-white" />
      </button>
      <div className="relative w-full h-full max-w-[90%] max-h-[90%]">
        <VideoPlayer
          youtubeVideoId={youtubeVideoId}
          playing
          title={title}
          {...props}
        />
      </div>
    </div>,
    document.body,
  )

export default VideoPlayerModal
